import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBAT5DTavD4bQKjB_zqDs6C0IdpcAKKLcw",
  authDomain: "baseballometer.firebaseapp.com",
  projectId: "baseballometer",
  storageBucket: "baseballometer.appspot.com",
  messagingSenderId: "1024329456395",
  appId: "1:1024329456395:web:59aa283661d3ff0327600e",
  measurementId: "G-3NFF93PPMD"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };